<div
    class="absolute translate-x-0 shadow-lg z-[9999] top-0 right-0 min-w-[300px] sm:max-w-[480px] h-screen transition-all duration-300 ease-out bg-white lg:invisible flex flex-col overflow-y-scroll"
>
    <div class="flex flex-col h-full">
        <div class="flex flex-col px-4 min-h-[800px] h-full">
            <div class="flex items-start justify-between py-4">
                <img [draggable]="false" class="h-8 cursor-pointer" routerLink="/" src="/logo.svg" />
                <lepi-icon (click)="close()" class="block bg-gray-800 cursor-pointer size-5" name="heroicons:x-mark"></lepi-icon>
            </div>
            @if (!user()) {
                <div class="flex items-center justify-between py-4">
                    <p class="font-bold text-gray-800">로그인 해주세요.</p>
                    <div class="flex items-center gap-1" routerLink="login">
                        <a (click)="close()" class="text-sm font-semibold text-gray-500" routerLink="/login">로그인</a>
                        <lepi-icon class="block cursor-pointer bg-primary size-5" name="solar:login-2-line-duotone"></lepi-icon>
                    </div>
                </div>
            } @else {
                <div class="flex items-center justify-between py-4" (click)="handleMyPage()">
                    <div class="flex items-center gap-3">
                        <img
                            [draggable]="false"
                            [src]="user()?.profileImage ? user()?.profileImage?.url : 'profile.svg'"
                            class="rounded-full size-12"
                        />
                        <div class="flex flex-col gap-2">
                            <p class="font-bold text-gray-800">{{ user()?.name }} 님</p>
                            <p class="text-sm text-gray-500">
                                {{ user()?.userId }}
                            </p>
                        </div>
                    </div>
                    <lepi-icon name="material-symbols:arrow-forward-ios" class="block bg-gray-300 cursor-pointer size-5" />
                </div>
            }

            <div class="px-4 border-b border-gray-200"></div>

            <div class="flex items-center gap-3 py-4">
                <div class="flex flex-col items-center flex-1 h-full gap-2 cursor-pointer" (click)="history()">
                    <img [draggable]="false" class="h-7" src="/icons/booked.svg" />
                    <p class="text-xs font-semibold text-center text-gray-800">예약내역</p>
                </div>
                <div class="flex flex-col items-center flex-1 h-full gap-2 cursor-pointer" (click)="magazine()">
                    <img [draggable]="false" class="h-7" src=" /icons/magazine.svg" />
                    <p class="text-xs font-semibold text-center text-gray-800">매거진</p>
                </div>
                <div class="flex flex-col items-center flex-1 h-full gap-2 cursor-pointer" (click)="activity()">
                    <img [draggable]="false" class="h-7" src="/icons/editor.svg" />
                    <p class="text-xs font-semibold text-center text-gray-800">내 활동</p>
                </div>
            </div>
            <div class="px-4 border-b border-gray-200"></div>
            <!-- 카테고리 -->
            <div class="flex flex-col justify-center cursor-pointer" auto-animate>
                @for (category of topLevelCategoryList(); track category.id) {
                    <div
                        class="flex items-center justify-between py-4 text-sm font-bold text-gray-800 hover:text-primary min-w-max"
                        routerLinkActive="text-primary"
                        (click)="moveTo(category)"
                    >
                        {{ category.name }}
                        <lepi-icon name="material-symbols:arrow-forward-ios" class="bg-gray-300 size-3"></lepi-icon>
                    </div>
                    <div
                        class="px-4 border-b border-gray-200"
                        [ngClass]="(topLevelCategoryList()?.length || 0) - 1 === $index ? 'hidden' : 'block'"
                    ></div>
                }
            </div>
        </div>

        <div class="px-4 border-b border-gray-200"></div>

        <div class="flex items-center justify-center py-4">
            @if (user()) {
                <div class="flex items-center justify-center w-full gap-1 px-4 border-r border-gray-200">
                    <button class="text-sm font-semibold text-gray-500 w-fit hover:text-primary" routerLink="/customer" (click)="logout()">
                        로그아웃
                    </button>
                    <lepi-icon class="block bg-primary size-5" name="solar:login-2-line-duotone"></lepi-icon>
                </div>
            }
            <div class="flex items-center justify-center w-full gap-1 px-4 cursor-pointer">
                <button class="text-sm font-semibold text-gray-500 w-fit hover:text-primary" routerLink="/customer" (click)="close()">
                    고객센터
                </button>
                <lepi-icon class="block bg-primary size-5" name="solar:phone-rounded-bold-duotone"></lepi-icon>
            </div>
        </div>
    </div>
</div>
